import { fetchWithTimeout } from './fetchWithTimeout';
import { Store } from './store';

export type Closed = {
    closedId?: string;
    closedFm?: Date;
    closedTo?: Date;
    msg?: string;
    createBy?: string;
    createDate?: Date;
    updateBy?: string;
    updateDate?: Date;
    store?: Store;
    select?: (keyof Closed)[];
    order?: { [P in keyof Closed]: 'ASC' | 'DESC' | 'asc' | 'desc' | 1 | -1 };
    loadEagerRelations?: boolean;
};

type CreateRequestData = Closed & {};

type CreateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Closed;
};

function create(data: CreateRequestData) {
    return fetchWithTimeout('closed/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type CreateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Closed[];
};

function createBulk(data: CreateRequestData[]) {
    return fetchWithTimeout('closed/createBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type GetRequestData = Closed & {
    closedFmSt?: Date;
    closedFmEd?: Date;
    closedToSt?: Date;
    closedToEd?: Date;
    select?: (keyof Closed)[];
    loadEagerRelations?: boolean;
};

type GetResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Closed[];
};

function get(data: GetRequestData) {
    return fetchWithTimeout('closed/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: GetResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateRequestData = Closed & { closedId: string };

type UpdateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Closed;
};

function update(data: UpdateRequestData) {
    return fetchWithTimeout('closed/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Closed[];
};

function updateBulk(data: UpdateRequestData[]) {
    return fetchWithTimeout('closed/updateBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type RemoveRequestData = Closed & { closedId: string };

type RemoveResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function remove(data: RemoveRequestData) {
    return fetchWithTimeout('closed/remove', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

function removeBulk(data: RemoveRequestData[]) {
    return fetchWithTimeout('closed/removeBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

export default { create, createBulk, get, update, updateBulk, remove, removeBulk };
